/* This is a mst-gql generated file, don't modify it manually */
 

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"


/**
 * AppointmentTypeBase
 * auto generated base class for the model AppointmentTypeModel.
 *
 * An appointment type
 */
export const AppointmentTypeModelBase = ModelBase
  .named('AppointmentType')
  .props({
    __typename: types.optional(types.literal("AppointmentType"), "AppointmentType"),
    id: types.identifier,
    isDefault: types.union(types.undefined, types.null, types.boolean),
    name: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore()
    }
  }))

export class AppointmentTypeModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get isDefault() { return this.__attr(`isDefault`) }
  get name() { return this.__attr(`name`) }
}
export function selectFromAppointmentType() {
  return new AppointmentTypeModelSelector()
}

export const appointmentTypeModelPrimitives = selectFromAppointmentType().isDefault.name
